import { differenceInCalendarDays, isEqual, parseISO } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { isString } from 'lodash';
import { useIntl } from '../theme/i18n';
export var useDateUtils = () => {
  var {
    timeZone,
    locale
  } = useIntl(); // eslint-disable-next-line no-restricted-syntax

  var createDate = dateStr => zonedTimeToUtc(dateStr ? parseISO(dateStr) : new Date(), timeZone);

  var isValidScheduledDate = scheduledDate => {
    var daysAfterToday = differenceInCalendarDays(isString(scheduledDate) ? parseISO(scheduledDate) : scheduledDate, createDate());
    return daysAfterToday >= 0;
  };

  var convertToDate = date => isString(date) ? createDate(date) : date;

  var isEqualDate = (dateLeft, dateRight) => isEqual(convertToDate(dateLeft), convertToDate(dateRight));

  var isDatePartEqual = (dateLeft, dateRight) => dateLeft.toLocaleDateString(locale, {
    timeZone
  }) === dateRight.toLocaleDateString(locale, {
    timeZone
  });

  return {
    createDate,
    isValidScheduledDate,
    isEqualDate,
    isDatePartEqual
  };
};
//# sourceMappingURL=useDateUtils.js.map